import { useState, useEffect } from 'react';
import qs from 'query-string';

export function useAtlassianContext(timeout = 8000) {
  const { lic } = qs.parse(window.location.search);

  const [context, setContext] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState('');
  const [isValidLicense, setValidLicense] = useState(lic === 'active');
  const [location, setLocation] = useState('');

  // useEffect(() => {
  //   let timeoutId;
  //   let isMounted = true;

  //   if (window.AP) window.AP.resize('100%');

  //   const { jwt } = qs.parse(window.location.search);
  //   setToken(jwt);

  //   const loadContext = async () => {
  //     try {
  //       // Set up timeout
  //       const timeoutPromise = new Promise((_, reject) => {
  //         timeoutId = setTimeout(() => {
  //           reject(new Error('Context loading timed out'));
  //         }, timeout);
  //       });

  //       // Race between the actual context fetch and the timeout
  //       const contextData = await Promise.race([window.AP.context.getContext(), timeoutPromise]);
  //       const location = await new Promise((resolve) => {
  //         window.AP.getLocation((locationData) => {
  //           try {
  //             resolve(locationData);
  //           } catch (ex) {
  //             resolve(null); // Resolve with null in case of error
  //           }
  //         });
  //       });

  //       if (location) {
  //         let domain = new URL(location);
  //         if (domain && domain.origin.includes('twinitdev')) {
  //           setValidLicense(true);
  //         }
  //       }
  //       if (isMounted) {
  //         clearTimeout(timeoutId);
  //         setLocation(location);
  //         setContext(contextData);
  //         setLoading(false);
  //       }
  //     } catch (err) {
  //       if (isMounted) {
  //         clearTimeout(timeoutId);
  //         setError(err);
  //         setLoading(false);
  //       }
  //     }
  //   };

  //   // Wait for AP to be available
  //   if (window.AP && window.AP.context) {
  //     loadContext();
  //   } else {
  //     const checkInterval = setInterval(() => {
  //       if (window.AP && window.AP.context) {
  //         clearInterval(checkInterval);
  //         loadContext();
  //       }
  //     }, 100);

  //     // Clear interval after timeout if AP never loads
  //     timeoutId = setTimeout(() => {
  //       clearInterval(checkInterval);
  //       if (isMounted) {
  //         setError(new Error('AP library failed to load'));
  //         setLoading(false);
  //       }
  //     }, timeout);
  //   }

  //   return () => {
  //     isMounted = false;
  //     clearTimeout(timeoutId);
  //   };
  // }, [timeout]);

  function waitForAP() {
    return new Promise((resolve) => {
      if (window.AP && window.AP.context) {
        resolve(window.AP);
        return;
      }

      const checkInterval = setInterval(() => {
        if (window.AP && window.AP.context) {
          clearInterval(checkInterval);
          resolve(window.AP);
        }
      }, 100);
    });
  }

  useEffect(() => {
    const { jwt } = qs.parse(window.location.search);
    setToken(jwt);
    if (window.AP) {
      console.log('window.AP.resize');
      window.AP.resize('100%');
      console.log('window.AP.resize OK');
    }

    async function initializeAP() {
      try {
        const AP = await waitForAP();
        const contextData = await new Promise((resolve) => {
          AP.context.getContext(resolve);
        });

        const location = await new Promise((resolve) => {
          window.AP.getLocation((locationData) => {
            try {
              resolve(locationData);
            } catch (ex) {
              resolve(null); // Resolve with null in case of error
            }
          });
        });

        if (location) {
          let domain = new URL(location);
          if (domain && domain.origin.includes('twinitdev')) {
            setValidLicense(true);
          }
        }
        setLocation(location);
        setContext(contextData);
        setLoading(false);
      } catch (error) {
        console.error('AP initialization failed:', error);
      }
    }

    initializeAP();
  }, []);

  return { context, token, isValidLicense, location, loading };
}
